/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_Provider_KepInputs */

const tr_mesafeli_s1_provider_kep = /** @type {(inputs: Mesafeli_S1_Provider_KepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; KEP`)
};

const en_mesafeli_s1_provider_kep = /** @type {(inputs: Mesafeli_S1_Provider_KepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; KEP`)
};

const de_mesafeli_s1_provider_kep = /** @type {(inputs: Mesafeli_S1_Provider_KepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; KEP`)
};

const ru_mesafeli_s1_provider_kep = /** @type {(inputs: Mesafeli_S1_Provider_KepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; KEP`)
};

/**
* | output |
* | --- |
* | "; KEP" |
*
* @param {Mesafeli_S1_Provider_KepInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_provider_kep = /** @type {((inputs?: Mesafeli_S1_Provider_KepInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_Provider_KepInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_provider_kep(inputs)
	if (locale === "de") return de_mesafeli_s1_provider_kep(inputs)
	if (locale === "ru") return ru_mesafeli_s1_provider_kep(inputs)
	return tr_mesafeli_s1_provider_kep(inputs)
});